import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 2 }
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_interview = _resolveComponent("interview")!
  const _component_visit = _resolveComponent("visit")!
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.loading && typeof(_ctx.request) !== 'undefined')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.request.request_type_id == _ctx.RequestType.INTERVIEW)
            ? (_openBlock(), _createBlock(_component_interview, {
                key: 0,
                request: _ctx.request
              }, null, 8, ["request"]))
            : (_ctx.request.request_type_id == _ctx.RequestType.VISIT)
              ? (_openBlock(), _createBlock(_component_visit, {
                  key: 1,
                  request: _ctx.request
                }, null, 8, ["request"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_2, _cache[0] || (_cache[0] = [
                  _createElementVNode("p", null, "Invalid Request Type", -1)
                ])))
        ]))
      : _createCommentVNode("", true),
    (!_ctx.loading && typeof(_ctx.request) === 'undefined')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _cache[1] || (_cache[1] = _createElementVNode("h4", null, "Error Loading Request", -1)),
          _createElementVNode("p", null, _toDisplayString(_ctx.error_message), 1)
        ]))
      : _createCommentVNode("", true),
    _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
    _createVNode(_component_loading, {
      active: _ctx.loading,
      "is-full-page": true
    }, null, 8, ["active"])
  ], 64))
}